import NetworkUtils from './network_utils.js'
import TextsHelper from './texts_helper.js'
import { getOwner } from './my_utils.js'
class PositionsHelper {
  constructor () {
    this.network_utils = new NetworkUtils()
    this.texts_helper = new TextsHelper()
  }

  logToServer (params) {
    if (params.old_status == params.new_status) {
      return
    }
    this.sendStatusStat({ old_status: params.old_status, new_status: params.new_status, resource_id: params.resource_id })
    this.sendActivationStat({ new_status: params.new_status, resource_id: params.resource_id, position_title: params.position_title, company_id: params.company_id })
  }

  sendStatusStat (params) {
    let position_status_changed_content = 'Old status was: ' + params.old_status + ', new status is: <b>' + params.new_status + '</b>'
    this.network_utils.postStat({
      designator: 'position_status_changed',
      resource_type: 'Position',
      resource_id: params.resource_id,
      owner: getOwner().name,
      title: 'Position Status Changed',
      priority: 5,
      content: position_status_changed_content
    })
  }

  sendActivationStat (params) {
    let content = params.position_title + ', Company: ' + params.company_id
    if (params.new_status == 'active') {
      this.network_utils.refreshPublicPositions()
      this.network_utils.postStat({
        designator: 'position_activated',
        resource_type: 'Position',
        resource_id: params.resource_id,
        owner: getOwner().name,
        title: 'Position Activated',
        priority: 5,
        content: 'Postion Activated: ' + content
      })
      return
    }
    this.network_utils.postStat({
      designator: 'position_deactivated',
      resource_type: 'Position',
      resource_id: params.resource_id,
      owner: getOwner().name,
      title: 'Position Deactivated',
      priority: 5,
      content: 'Position Deactivated: ' + content
    })
  }

  getCVRecipient (position) {
    let position_texts_request = this.network_utils.getResourceTexts({
      current_type: 'Position',
      current_resource_id: position.id
    })
    let requests = [position_texts_request]
    return new Promise((resolve, reject) => {
      this.network_utils.caller.axios.all(requests).then(response => {
        let position_texts = response[0]
        let recipient = this.validateRecipient(position, position_texts)
        resolve(recipient)
      })
    })
  }

  validateRecipient (position, position_texts) {
    let position_contact_email = this.texts_helper.getContent(
      this.texts_helper.getTextByDesignator(position_texts, 'contact_email')
    )
    let company_contact_email = position.company.contact_email
    if (position_contact_email != '') {
      return position_contact_email
    }
    if (company_contact_email != '') {
      return company_contact_email
    }
    return position.company.email
  }
}

export default PositionsHelper
